export default "__VITE_ASSET__8KaHRJVN__"